import React, { useContext } from "react";
import { NavbarContext } from "../App";
import { Route, Routes } from "react-router-dom";
import Navbar from "../components/navbar/Navbar";
import ProtectedRoute from "../components/helpers/ProtectRoute";
import Profile from "../views/profile";
import PricingPage from "../views/pricing";
import CleanupCalculator from "../views/cleanupCalculator/index";
import GcQualify from "../views/planify/GcQualify";
import ProjectBoardList from "../views/projectBoardList/ProjectBoardList";
import { ProjectBoard } from "../views/projectBoard/ProjectBoard";
import { ProjectOverview } from "../views/projectsOverview/index";
import Home from "../views/home";
import DocumentGenerator from "../views/proposal/documentGenerator";
import PaintDocumentGenerator from "../views/paintProposal/documentGenerator";
import Proposal from "../views/proposal";
import ProposalTemplate from "../views/proposal/proposalTemplate";
import Planify from "../views/planify";
import PlanRoom from "../views/planify/planroom";
import ProjectFavorite from "../views/projects/favorite";
import ProjectRecent from "../views/projects/viewed";
import SavedSearhces from "../views/projects/saved";
import ProjectArchive from "../views/projects/archived";
import Calculator from "../views/cleanupCalculator/calculator_index";
import CleanupRates from "../views/cleanupCalculator/cleanup_rates";
import CompanyDetailsForms from "../views/prequelMasterKey/CompanyDetailsForms";
import PDF from "../views/capabilityStatement/index";
import PDFVersion_A from "../views/capabilityStatement/Versions/PDFVersion_A";
import PDFVersion_B from "../views/capabilityStatement/Versions/PDFVersion_B";
import ProjectBoardV2 from "../views/mapV2";
import StatementDocReadOnly from "../views/capabilityStatement/StatementDocReadOnly";
import ContactOutreach from "../views/ContactOutreach";
import { ProjectTable } from "../views/projectTable";
import OnboardingWizard from "../views/onBoardingWizard";
import Pricing from "../views/pricing/Pricing";
import SiteVisit from "../views/siteVisit";
import Referral from "../views/Referral";
import SiteRouteRouter from "../views/siteRouteRouter/siteRouteRouter";
import Dashboard from "../views/dashboard";
import Deal from "../views/deals";
import { DealBoard } from "../views/dealBoard/DealBoard";
import DealMarketplace from "../views/dealsMarketplace";
import Reauth from "../views/stripeOnboardingRedirect/reauth";
import OnboardingReturn from "../views/stripeOnboardingRedirect/onBoardingReturn";
import CloudApps from "../views/cloudSuiteApps";
import ContactManagement from "../views/contactManagement";
import ContactEnrichment from "../views/contactEnrichment";
import ITBImport from "../views/itbImport";
import SearchOpportunitiesPage from "../views/searchOpportunities/SearchOpportunitiesPage";
import SearchOpportunitiesResultsPage from "../views/searchOpportunities/SearchOpportunitiesResultsPage";
import EmailTemplates from "../views/emailTemplates";

const AuthRoutes = () => {
  const { showLargeScreenNav } = useContext(NavbarContext);
  return (
    <>
      <Navbar />
      <div
      // className={classNames(
      //   "page-container",
      //   showLargeScreenNav ? "move-page" : "unmove-page"
      // )}
      >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/cloud-suite-apps" element={<CloudApps />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/proposal" element={<Proposal />} />
          <Route path="/my_proposal" element={<DocumentGenerator />} />
          <Route path="my_proposal/edit/:id" element={<DocumentGenerator />} />
          <Route path="/paint_proposal" element={<PaintDocumentGenerator />} />
          <Route
            path="paint_proposal/edit/:id"
            element={<PaintDocumentGenerator />}
          />
          <Route
            path="/cleanup_calculator_overview"
            element={<Calculator />}
          ></Route>
          <Route path="/cleanup_calculator" element={<CleanupCalculator />} />
          <Route path="/cleanup_rates" element={<CleanupRates />} />
          <Route path="/pre_qualify" element={<GcQualify />} />
          <Route path="/planify" element={<Planify />} />
          <Route
            path="/cleanup_calculator/edit/:id"
            element={<CleanupCalculator />}
          />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/project_board" element={<ProjectBoardList />} />
          <Route
            path="/search"
            element={
              <ProtectedRoute>
                <SearchOpportunitiesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/search/results"
            element={
              <ProtectedRoute>
                <SearchOpportunitiesResultsPage />
              </ProtectedRoute>
            }
          />
          <Route path="/site_router" element={<SiteRouteRouter />} />
          <Route path="/project_research" element={<ProjectTable />} />
          <Route path="/projects_overview" element={<ProjectOverview />} />

          <Route
            path="/project_board/:projectSlug"
            element={<ProjectBoard />}
          />

          <Route path="/crm" element={<ContactManagement/>} />
          <Route path="/enrich" element={<ContactEnrichment/>} />
          <Route path="/deal/:projectSlug" element={<DealBoard />} />
          {/* <Route path="/deal/marketplace" element={<DealMarketplace />} /> */}
          <Route path="/create_deal" element={<Deal />} />
          <Route path="/deal/edit/:id" element={<Deal />} />
          <Route path="/itb-import" element={<ITBImport />} />
          <Route path="/reauth" element={<Reauth />} />
          <Route path="/onboarding-return" element={<OnboardingReturn />} />

          <Route path="/site_visit" element={<SiteVisit />} />
          <Route path="/site_visit/edit/:id" element={<SiteVisit />} />
          {/*<Route path="/myproposal" element={<MyProposal />} />*/}
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route path="/proposal_templates" element={<ProposalTemplate />} />
          <Route
            path="/email_templates"
            element={
              <ProtectedRoute>
                <EmailTemplates />
              </ProtectedRoute>
            }
          />
          <Route path="/plan_room" element={<PlanRoom />} />
          <Route
            path="/myganarpro/favorites"
            element={
              <ProtectedRoute>
                <ProjectFavorite />
              </ProtectedRoute>
            }
          />
          <Route
            path="/myganarpro/hiddenProjects"
            element={
              <ProtectedRoute>
                <ProjectArchive />
              </ProtectedRoute>
            }
          />
          <Route
            path="/myganarpro/recentlyViewed"
            element={
              <ProtectedRoute>
                <ProjectRecent />
              </ProtectedRoute>
            }
          />
          <Route
            path="/myganarpro/savedSearches"
            element={
              <ProtectedRoute>
                <SavedSearhces />
              </ProtectedRoute>
            }
          />
          <Route path="/capability_statement" element={<PDF />} />
          <Route
            path="/capability_statement/Version-A"
            element={<PDFVersion_A />}
          />
          <Route
            path="/capability_statement/Version-B"
            element={<PDFVersion_B />}
          />

          <Route path="/qualkey" element={<CompanyDetailsForms />} />
          <Route path="/capability_statement" element={<PDF />} />
          <Route
            path="/capability_statement/Version-A"
            element={<PDFVersion_A />}
          />
          <Route
            path="/capability_statement/Version-B"
            element={<PDFVersion_B />}
          />
          <Route
            path="/capability_statement/share/:uniqueLink"
            element={<StatementDocReadOnly />}
          />
          <Route path="/mapv2" element={<ProjectBoardV2 />} />
          <Route
            path="/contact_outreach"
            element={
              <ProtectedRoute>
                <ContactOutreach />
              </ProtectedRoute>
            }
          />
          <Route
            path="/onboarding"
            element={
              <ProtectedRoute>
                <OnboardingWizard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/referral/invite"
            element={
              <ProtectedRoute>
                <Referral />
              </ProtectedRoute>
            }
          />
          <Route path="/pricing1" element={<Pricing />} />
        </Routes>
      </div>
    </>
  );
};

export default AuthRoutes;
